module.exports = __webpack_public_path__ + "img/Up Entertainment.0980407f.png";